import { Expose } from 'class-transformer';
import { DefaultUUIDViewDto } from '../../../common/dto/default-uuid-view.dto';

export class ViewProfileDto extends DefaultUUIDViewDto {
  @Expose() firstName: string;
  @Expose() lastName: string;
  @Expose() mobilePhone: string;
  @Expose() officePhone: string;
}
